import { Nullable } from '@/shared/types/app.types'
import { CommonLaboratoryResponse } from '@/api/services/common.dto'

export enum SynopticTemplateNodeType {
    TITLE = 'TITLE',
    VARIABLE_TEXT = 'VARIABLE_TEXT',
    VARIABLE_NUMBER = 'VARIABLE_NUMBER',
    VARIABLE_PERCENTAGE = 'VARIABLE_PERCENTAGE',
    VARIABLE_DATE = 'VARIABLE_DATE',
    VARIABLE_IMAGE = 'VARIABLE_IMAGE'
}

export enum SynopticTemplateNodeChildrenSelectionType {
    NONE = 'NONE',
    SINGLE_SELECTION = 'SINGLE_SELECTION',
    MULTIPLE_SELECTION = 'MULTIPLE_SELECTION'
}

export interface SynopticTemplateNode {
    nodeType: SynopticTemplateNodeType
    allowsChildrenSelection: SynopticTemplateNodeChildrenSelectionType
    text: string
    code: string
    morphologicCodeId?: Nullable<number>
    topographicCodeId?: Nullable<number>
    required: boolean
    children?: Nullable<SynopticTemplateNode[]>
}

export interface ConfigurationSynopticTemplateResponse {
    id: number
    title: string
    active: boolean
    laboratory: CommonLaboratoryResponse
    tree: SynopticTemplateNode[]
}

export interface ConfigurationSynopticTemplateCreateRequest {
    title: string
    active: boolean
    tree: SynopticTemplateNode[]
}

export interface ConfigurationSynopticTemplatePatchInBatchRequest {
    id: number
    title?: Nullable<string>
    active?: Nullable<boolean>
    tree?: Nullable<SynopticTemplateNode[]>
}
